<template>
  <div class="c-banner-link" :class="classObject">
    <div class="c-banner-link__slot" v-show="false">
      <slot></slot>
    </div>
    <a :href="href" class="c-banner-link__anchor" v-background="image">
      <div class="c-banner-link__caption" v-html="caption"></div>
    </a>
  </div>
</template>

<script>
import u from "../lib/u";

export default {

  props: ["modifier"],

  data (){
    return {
      state: false,
      href: null,
      caption: null,
      image: null,
    }
  },

  computed: {
    classObject (){
      let o = {};
      o["-active"] = this.state;
      if(this.modifier){
        o[this.modifier] = true;
      }
      return o;
    }
  },

  mounted (){
    // fetch slot
    const slot = this.$el.querySelector(".c-banner-link__slot");
    this.href = slot.querySelector("a").href;
    this.caption = slot.querySelector(".caption").innerHTML;
    // this.image = slot.querySelector("img").src;
    this.image = u.parseSrcset(slot.querySelector("img"));

    setTimeout(() => {
      this.state = true;
    }, 100);
  },

  directives: {
    background (el, o){
      el.style.backgroundImage = `url(${o.value})`;
    }
  }
  
}
</script>




// WEBPACK FOOTER //
// src/component/banner-link.vue